module.exports = __webpack_public_path__ + "assets/img/34_892_big.f6b88307.jpg";